<template>
  <div
    :class="{
      [`
        bg-gray-900
        bg-opacity-50
        bottom-0
        fixed
        h-full
        left-0
        overflow-auto
        right-0
        scrolling-touch
        top-0
        w-full
        z-40
      `]: isFullPage,
    }"
  >
    <div
      :class="{ 'h-full w-full': isFullPage }"
      class="flex items-center justify-center"
    >
      <div
        v-for="(_, index) in 4"
        :key="`loading-dot-${index}`"
        :class="`bg-${color}`"
        class="loading__dot relative"
      />
    </div>
  </div>
</template>

<script>
import WLoading from './WLoading';

export default WLoading;
</script>

<style lang="scss" scoped>
@import 'WLoading';
</style>
